import PropertyDetail from "../../commonComponents/productDetail/PropertyDetail";

const PropertyThumbSliderContainer = () => {
  return <PropertyDetail type="tabs" mainClass="thumb-breadcrumbs-section" thumb />;
};

export default PropertyThumbSliderContainer;
